import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackward = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 30.85L22.5 35.85V21.55C22.5 21.1167 22.6417 20.7583 22.925 20.475C23.2083 20.1917 23.5667 20.05 24 20.05C24.4333 20.05 24.7917 20.1917 25.075 20.475C25.3583 20.7583 25.5 21.1167 25.5 21.55V35.9L30.55 30.9C30.85 30.6 31.2 30.45 31.6 30.45C32 30.45 32.35 30.6 32.65 30.9C32.95 31.2 33.1 31.55 33.1 31.95C33.1 32.35 32.9667 32.6833 32.7 32.95L25.1 40.55C24.9333 40.7167 24.7667 40.8333 24.6 40.9C24.4333 40.9667 24.25 41 24.05 41C23.85 41 23.6667 40.9667 23.5 40.9C23.3333 40.8333 23.1667 40.7167 23 40.55L15.45 33C15.15 32.7 15 32.35 15 31.95C15 31.55 15.15 31.2 15.45 30.9C15.75 30.6 16.1 30.45 16.5 30.45C16.9 30.45 17.2333 30.5833 17.5 30.85Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.5 24.999V28.3725L5.81398 21.3339C5.31418 21.0769 5 20.562 5 20C5 19.438 5.31418 18.9231 5.81398 18.6661L22.3993 10.1365C23.4039 9.61983 24.5961 9.61983 25.6007 10.1365L42.186 18.6661C42.6858 18.9231 43 19.438 43 20C43 20.562 42.6858 21.0769 42.186 21.3339L28.5 28.3725V24.999L38.2202 20L24.2287 12.8044C24.0852 12.7305 23.9148 12.7305 23.7713 12.8043L9.77978 20L19.5 24.999Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.5 28.3725V24.999L9.77978 20L23.7713 12.8043C23.9148 12.7305 24.0852 12.7305 24.2287 12.8044L38.2202 20L28.5 24.999V28.3725L42.186 21.3339C42.6858 21.0769 43 20.562 43 20C43 19.438 42.6858 18.9231 42.186 18.6661L25.6007 10.1365C24.5961 9.61983 23.4039 9.61983 22.3993 10.1365L5.81398 18.6661C5.31418 18.9231 5 19.438 5 20C5 20.562 5.31418 21.0769 5.81398 21.3339L19.5 28.3725Z",
			fill: "currentColor"
		})
	]
});
export default SvgBackward;
